/**
 * 其知网 出售管理
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <!-- <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item> -->
      <el-breadcrumb-item>求购管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="搜索：">
        <el-input size="small" v-model="formInline.search" style="width:140px" placeholder="输入搜索关键词"></el-input>
        状态：
        <el-select size="small" v-model="formInline.status" style="width:140px" placeholder="请选择">
          <el-option v-for="type in buyStatus" :label="type.key" :value="type.value" :key="type.value"></el-option>
        </el-select>

      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button size="small" type="primary" icon="" title="批量审核勾选求购信息" @click="verifyCheckBuy">审核</el-button>
        <el-button size="small" type="danger" icon="" title="批量删除勾选中的数据" @click="delCheckBuy">删除</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" ref="multipleTable" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;" tooltip-effect="dark"  @selection-change="handleSelectionChange">
      <el-table-column align="center" type="selection" width="40">
      </el-table-column>
      <el-table-column align="center" type="index" label="序号" width="50">
      </el-table-column>
      <el-table-column prop="id" v-if="idShow">
      </el-table-column>
      <el-table-column prop="need_desc" align="center" label="求购需求" width="500px" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="pc_mobile" align="center" label="联系方式" width="100px" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="status" align="center" label="状态" :formatter="statusFormat" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="admin_name" align="center" label="操作人" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="note" align="center" label="备注" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="add_time" align="center" label="发布时间" width="150px" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="upd_time" align="center" label="更新时间" show-overflow-tooltip>
      </el-table-column>
      <el-table-column align="center" label="操作" width="250px">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" @click="handleverify(scope.$index, scope.row)">审核</el-button>
          <el-button size="mini" type="danger" @click="delBuy(scope.$index, scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>

    <!-- 审核界面 -->
    <el-dialog :title="title" :visible.sync="verifyFormVisible" width="50%" @click="closeDialog('verifyForm')">
        <el-form label-width="120px" :model="verifyForm" ref="verifyForm" :rules="verifyFormRules">
          <el-row>
              <el-form-item label="求购需求" prop="need_desc">
                <el-input size="small" v-model="verifyForm.need_desc" auto-complete="off" disabled></el-input>
              </el-form-item>
              <el-form-item label="联系方式" prop="pc_mobile">
                <el-input size="small" v-model="verifyForm.pc_mobile" auto-complete="off" disabled></el-input>
              </el-form-item>
              <el-form-item label="是否通过" prop="status">
                  <el-radio-group type="status" v-model="verifyForm.status"> 
                      <el-radio v-model="verifyForm.status" :label="2" style="font-size: 25px">通过</el-radio>
                      <el-radio v-model="verifyForm.status" :label="3">不通过</el-radio>
                  </el-radio-group>
              </el-form-item>
              <el-form-item label="备注" prop="note">
                <el-input size="small" v-model="verifyForm.note" auto-complete="off" placeholder="若审核不通过请填写原因"></el-input>
              </el-form-item>
              <el-form-item>
                <el-button size="mini" type="primary" @click="submitVerifyForm('verifyForm')">保存</el-button>
                <el-button size="mini" @click='closeDialog("verifyForm")'>取消</el-button>
              </el-form-item>
          </el-row>
        </el-form>
    </el-dialog>

    <!-- 选中审核页面 -->
    <el-dialog :title="title" :visible.sync="verifyCheckVisible" width="50%" @click="closeDialog('verifyCheck')">
        <el-form label-width="120px" :model="verifyCheck" ref="verifyCheck" :rules="verifyCheckRules">
          <el-row>
              <el-form-item label="是否通过" prop="status">
                  <el-radio-group type="status" v-model="verifyCheck.status"> 
                      <el-radio v-model="verifyCheck.status" :label="2" style="font-size: 25px">通过</el-radio>
                      <el-radio v-model="verifyCheck.status" :label="3">不通过</el-radio>
                  </el-radio-group>
              </el-form-item>
              <el-form-item label="备注" prop="note">
                <el-input size="small" v-model="verifyCheck.note" auto-complete="off" placeholder="若审核不通过请填写原因"></el-input>
              </el-form-item>
              <el-form-item>
                <el-button size="mini" type="primary" @click="submitVerifyCheck('verifyCheck')">保存</el-button>
                <el-button size="mini" @click='closeDialog("verifyCheck")'>取消</el-button>
              </el-form-item>
          </el-row>
        </el-form>
    </el-dialog>

  </div>
</template>

<script>
import { webUrl, webDelCategory, webMarketBuyList, webMarketVerifyBuy, webMarketVerifyCheckBuy, webMarketDelBuy, webMarketDelCheckBuy } from '../../api/webMG'
import Pagination from '../../components/Pagination'
// import Upload from '../../components/upload.vue'

//引入ali-oss
import { client, getFileNameUUID } from '@/utils/ali-oss'

import { checkLogin } from '../../utils/util'
export default {
  name: "Upload",
  props: {
    limit: {
    type: Number,
    default: 1
    }
    },
  data() {
    return {

      idShow: false,
      loading: false, //是显示加载
      verifyFormVisible: false,// 控制审核页面显示与隐藏
      verifyCheckVisible: false,// 控制选中审核页面显示与隐藏
      uploadUrl: '',
      title: '添加分类',
      excelUrl: '',
      multipleSelection: [],
      buyStatus: [
        { key: '全部', value: 0 },
        { key: '待审核', value: 1 },
        { key: '正常', value: 2 },
        { key: '未通过', value: 3 }
      ],
      setHeader:{
        'token': localStorage.getItem('logintoken')
      },
      // 审核数据model
      verifyForm: {
        id: '',
        need_desc: '',
        pc_mobile: '',
        status: '',
        note: '',
      },
       // 批量审核数据model
      verifyCheck: {
        ids: '',
        status: '',
        note: '',
      },
       formInline: {
        page: 1,
        ps: 10,
        search: '',
        status: '',
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      },
      // 审核 表单验证
      verifyFormRules: {
        status: [
          {required: true, message: '请选择是否通过', trigger: 'blur'}
          ],
      },
      // 选中审核 表单验证
      verifyCheckRules: {
        status: [{required: true, message: '请选择是否通过', trigger: 'blur'}],
      },
    }
  },
  // 注册组件
  components: {
    Pagination, 
    // Upload
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.getdata(this.formInline)
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    // 获取求购列表
    getdata(parameter) {
        console.log(parameter)
        this.loading = true
      /***
       * 调用接口，注释上面模拟数据 取消下面注释
       */
      webMarketBuyList(parameter)
        .then(res => {
          this.loading = false
          console.log(res);
          res = checkLogin(res)
          if (res.code == 200) {
            this.listData = res.data.dataList
            // 分页赋值
            this.pageparm.currentPage = this.formInline.page
            this.pageparm.pageSize = this.formInline.limit
            this.pageparm.total = res.data.total
          } else {
            this.$message({
              type: 'info',
              message: res.msg
            })
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('登陆已过期,请重新登陆!')
        })
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.ps = parm.pageSize
      this.getdata(this.formInline)
    },
    // 搜索事件
    search() {
      this.getdata(this.formInline)
    },
    handleSelectionChange(val){
      this.multipleSelection = val;
    },
    // 显示审核页
    handleverify: function(index, row) {
      if (row != undefined && row != 'undefined') {
              
        this.verifyFormVisible = true
        this.title = '求购审核'
        this.verifyForm.id = row.id
        this.verifyForm.need_desc = row.need_desc
        this.verifyForm.pc_mobile = row.pc_mobile
        if(row.status == 1){
          this.verifyForm.status = ''
        }else{
          this.verifyForm.status = row.status
        }
        this.verifyForm.note = row.note
      }else{
        this.$message({
              type: 'error',
              message: '未知错误,请联系开发人员'
        })
      }
    },
    // 提交审核
    submitVerifyForm(verifyForm) {
      this.$refs[verifyForm].validate(valid => {
        if (valid) {
          webMarketVerifyBuy(this.verifyForm)
            .then(res => {
              this.verifyFormVisible = false
              this.loading = false
              res = checkLogin(res)
              if (res.code == 200) {
                this.getdata(this.formInline)
                this.$message({
                  type: 'success',
                  message: res.msg
                })
              } else {
                this.$message({
                  type: 'error',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.verifyFormVisible = false
              this.loading = false
              this.$message.error('系统错误！')
            })
        } else {
          return false
        }
      })
    },
    // 求购状态
    statusFormat:function(row,column){
        if(row.status == 1){
            return '待审核'
        }else if(row.status == 2){
            return '正常'
        }else if(row.status == 3){
            return '未通过'
        }else{
            return '未知'
        }
    },
      // 审核选中的专利出售记录 
    verifyCheckBuy(){
        const checkedArr = this.multipleSelection;
        const idsArr = [];
        checkedArr.forEach(function(item,index){
            idsArr.push(item.id)
        });
        if(idsArr.length <= 0){
            this.$message({
              type: 'info',
              message: '未勾选任何记录'
          })
          return false;
        }
        this.title = '批量审核选中求购'
        this.verifyCheckVisible = true
        this.verifyCheck.ids = JSON.stringify(idsArr)
    },
       // 提交 审核选中的专利出售记录
    submitVerifyCheck(verifyCheck){
      this.$refs[verifyCheck].validate(valid => {
        if (valid) {
          webMarketVerifyCheckBuy(this.verifyCheck)
            .then(res => {
              res = checkLogin(res)
              if (res.code == 200) {
                this.$message({
                  type: 'success',
                  message: res.msg
                })
              this.verifyCheckVisible = false
              this.loading = false
              this.getdata(this.formInline)
              } else {
                this.$message({
                  type: 'error',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.$message.error('系统错误！')
              this.verifyCheckVisible = false
              this.loading = false
            })
        } else {
          return false
        }
      })
    },
    // 删除专利出售记录
    delBuy(index, row) {
        this.$confirm('确定要删除吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          const delParam = {id:row.id}
          webMarketDelBuy(delParam)
            .then(res => {
              if (res.code == 200) {
                this.$message({
                  type: 'success',
                  message: res.msg
                })
                this.getdata(this.formInline)
              } else {
                this.$message({
                  type: 'error',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('分类删除失败，请稍后再试！')
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
        // 删除所有选中的专利出售记录
    delCheckBuy(){
        const checkedArr = this.multipleSelection;
        const idsArr = [];
        checkedArr.forEach(function(item,index){
            idsArr.push(item.id)
        });
        if(idsArr.length <= 0){
            this.$message({
              type: 'info',
              message: '未勾选任何记录'
          })
          return false;
        }
      //添加提示框，确定后再导出，防止乱点，减轻服务器压力
      this.$confirm('确定删除勾选的记录吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
      .then(() => {
        const idStr = JSON.stringify(idsArr)
        const delParam = {ids:idStr}
        webMarketDelCheckBuy(delParam)
        .then(res=>{
          this.loading = false
          console.log(res);
          res = checkLogin(res);
          if (res.code == 200) {
              this.$message({
                  type: 'success',
                  message: '删除成功'
            })
              this.getdata(this.formInline)
          } else {
              this.$message({
                  type: 'info',
                  message: res.msg
            })
          }
        })
        })
         .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 关闭编辑、增加弹出框
    closeDialog(formName) {
      if(formName == 'verifyForm'){
        this.verifyFormVisible = false
      }else if(formName == 'editForm'){
        this.editFormVisible = false
      }else{
        return false
      }
      this.$refs[formName].resetFields()
    },
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>

 
 

 


// WEBPACK FOOTER //
// src/views/web/Buy.vue